import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'cva-page-not-found',
    templateUrl: './page-not-found.component.html',
    
})
export class PageNotFoundComponent {

}
